const l = `<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14">
  <path
    d="m2.378 9.9 5.139-4.627L2.377.645.69 2.205l3.4 3.042v.051L.69 8.341 2.378 9.9Zm14.19 3.299V11H8.591v2.199h7.977Z"
    fill-rule="nonzero" fill="currentColor" />
</svg>`;
export {
  l as default
};
